module.exports = __webpack_public_path__ + "img/kr-product-card2-bottom-bg.2daf360.png";